import React from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import Leftbar from '../Components/Sidebar/Leftbar'
import TestList from '../Components/SatTest/TestList'

function SatTestPage() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          marginLeft: 24,
          marginTop: 24,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <SHeaderbar />
        <div style={{ flex: 1, padding: 0, minHeight: 0 }}>
          <TestList />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default SatTestPage
